import { render, staticRenderFns } from "./xialadanxuan.vue?vue&type=template&id=6612400c&"
import script from "./xialadanxuan.vue?vue&type=script&lang=ts&"
export * from "./xialadanxuan.vue?vue&type=script&lang=ts&"
import style0 from "./xialadanxuan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports